import { render } from "./rules-text.vue?vue&type=template&id=5975f1ef"
import script from "./rules-text.vue?vue&type=script&lang=js"
export * from "./rules-text.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__